import {
  ChevronLeft,
  ChevronRight,
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import {
  Avatar,
  Badge,
  Box,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { Fragment } from "react";
import SettingIco from "../../../assets/icons/SettingsIcon";
import { CommonGrid2 } from "../../../modules/common-components/StyledComponents";
import {
  CommonTippy,
  CustomizeSpan,
  EllipseData,
} from "../../../modules/jobs/style";
import CreditCoinSmallIco from "../../../assets/icons/CreditCoinSmallIco";
import SideBarNotificationIco from "../../../assets/icons/SideBarNotificationIco";
import { platformWhiteLogo } from "../../../utils/logo";

const Sidebar = ({
  open,
  handleNavigation,
  lgUp,
  theme,
  expandedItems,
  handleExpandToggle,
  handleToggleDrawer,
  fullUrl,
  storageData,
  location,
  SidebarItems,
  toggleDrawer,
  localStorage_data,
  handleNotification,
  notification_data,
}) => {
  const updatedVersion = process.env.REACT_APP_URL_VERSION;

  console.log(open, localStorage_data, "sflsnfkjsfjknsfkj");
  return (
    <Drawer
      variant={open && !lgUp ? "temporary" : "permanent"}
      open={open}
      anchor="left"
      onClose={handleToggleDrawer}
      sx={{
        "& .MuiDrawer-paper": {
          width: open ? 290 : theme.spacing(8),
          transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.standard,
          }),
          overflowX: "hidden",
        },
        backgroundColor: "#1A1425",
        position: "relative",
      }}
    >
      <CommonGrid2
        container
        direction="column"
        height={"100vh"}
        flexWrap={"nowrap"}
        padding={"16px 16px 8px"}
        margin={0}
        backgroundColor={"#1A1425"}
      >
        <CommonGrid2
          item
          marginTop={"5px"}
          marginLeft={"2px"}
          sx={{ cursor: "pointer" }}
          onClick={() => handleNavigation("/auth/login")}
        >
          {localStorage_data?.org_label ||
          typeof localStorage_data?.org_logo_url === "string" ? (
            <CommonGrid2 display={"flex"} alignItems={"start"} gap={"10px"}>
              {typeof localStorage_data?.org_logo_url === "string" ? (
                <Avatar
                  src={localStorage_data?.org_logo_url}
                  sx={{
                    width: "40px",
                    height: "40px",
                  }}
                />
              ) : (
                <Avatar
                  sx={{
                    width: "40px",
                    height: "40px",
                  }}
                >
                  {localStorage_data?.organization?.charAt(0)?.toUpperCase()}
                </Avatar>
              )}

              <CommonGrid2
                display={"flex"}
                flexDirection={"column"}
                gap={"4px"}
                height={open ? "auto" : "60px"}
              >
                <Typography variant="h5" color="#fff" fontWeight={700}>
                  {localStorage_data?.organization}
                </Typography>
                <Typography
                  variant="h6"
                  color="#ff36e3"
                  // fontSize={"18px"}
                  fontWeight={500}
                  marginTop="-5px"
                  padding={"0px"}
                >
                  {localStorage_data?.agency_type === "Recruiting Agency"
                    ? "Agency"
                    : localStorage_data?.agency_type === "Delivery Agency"
                    ? "Delivery"
                    : localStorage_data?.agency_type === "VMS"
                    ? "Supply Network"
                    : localStorage_data?.agency_type === "Hiring Teams"
                    ? "Client"
                    : "Candidate"}
                </Typography>
              </CommonGrid2>
            </CommonGrid2>
          ) : (
            <Fragment>
              {platformWhiteLogo()}
              <Typography
                variant="h6"
                color="#ff36e3"
                fontSize={"18px"}
                marginLeft={"3rem"}
                fontWeight={500}
                marginTop="-5px"
                padding={"0px"}
              >
                {storageData?.agency_type === "Recruiting Agency"
                  ? "Agency"
                  : storageData?.agency_type === "Delivery Agency"
                  ? "Delivery"
                  : storageData?.agency_type === "VMS"
                  ? "Supply Network"
                  : storageData?.agency_type === "Hiring Teams"
                  ? "Client"
                  : "Candidate"}
              </Typography>
            </Fragment>
          )}
        </CommonGrid2>
        <Box
          padding={theme.spacing(1)}
          position={"fixed"}
          top={"3.5rem"}
          zIndex={"9999"}
          left={open ? "265px" : "38px"}
          sx={{
            // transition: theme.transitions.create(["right"], {
            //   duration: theme.transitions.duration.short,
            //   easing: theme.transitions.easing.easeInOut,
            // }),
            transition: theme.transitions.create(["left"], {
              duration: theme.transitions.duration.short,
              easing: theme.transitions.easing.easeInOut,
            }),
            "& button": {
              borderRadius: "10px",
              padding: "5px",
            },
          }}
        >
          <IconButton
            className="demoerer"
            onClick={toggleDrawer}
            sx={{
              background: "#7F56D9",
              color: "#fff",
              "&:hover": { background: "#7F56D9" },
            }}
          >
            {open ? <ChevronLeft /> : <ChevronRight />}
          </IconButton>
        </Box>
        <CommonGrid2
          item
          flexGrow={1}
          overflowY={"auto"}
          width={open ? "calc(100% + 16px)" : "fit-content"}
          scrollStyle
          marginBottom={"12px"}
          scrollBar="5px"
          paddingRight={"10px"}
        >
          <List sx={{ width: "100%" }} component="nav">
            {SidebarItems.map((item, index) => (
              <React.Fragment key={item.name}>
                <ListItemButton
                  onClick={() =>
                    item.children
                      ? handleExpandToggle(index)
                      : handleNavigation(item.path)
                  }
                  selected={location.pathname.includes(item.path)}
                  sx={{
                    width: open ? "100%" : "max-content",
                    padding: "8px 8px",
                    background: location.pathname.includes(item.path)
                      ? "rgb(230 230 230)"
                      : "",
                    borderRadius: "10px",
                    boxShadow:
                      location.pathname.includes(item.path) &&
                      "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                  }}
                >
                  <CommonTippy
                    content={item.name}
                    placement="right"
                    disabled={open}
                    color="#7F56D9"
                    fontWeight={600}
                    fontSize={"13px"}
                  >
                    <ListItemIcon
                      sx={{
                        justifyContent: "flex-start",
                        minWidth: "40px",
                      }}
                    >
                      {React.cloneElement(item.icon, {
                        color: location.pathname.includes(item.path)
                          ? "#7F56D9"
                          : "#667085",
                      })}
                    </ListItemIcon>
                  </CommonTippy>
                  <ListItemText
                    primary={
                      <Typography
                        variant="body4"
                        fontWeight={
                          location.pathname.includes(item.path) ? 700 : 600
                        }
                        color={
                          location.pathname.includes(item.path)
                            ? "#7F56D9"
                            : "#FFFFFF"
                        }
                      >
                        {item.name}
                      </Typography>
                    }
                  />
                  {item.children &&
                    (expandedItems[index] ? (
                      <ExpandLess sx={{ color: "white" }} />
                    ) : (
                      <ExpandMore sx={{ color: "white" }} />
                    ))}
                </ListItemButton>
                {item.children && (
                  <Collapse
                    in={expandedItems[index]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List
                      component="div"
                      disablePadding
                      sx={{ marginLeft: open ? "2.5rem" : "3rem" }}
                    >
                      {item.children.map((child) => (
                        <ListItemButton
                          key={child.name}
                          // selected={location.pathname.includes(child.path)}
                          selected={
                            child.check === "common"
                              ? fullUrl.includes(child.path)
                              : location.pathname.includes(child.path)
                          }
                          onClick={() => handleNavigation(child.path)}
                          sx={{
                            background:
                              location.pathname.includes(child.path) ||
                              fullUrl.includes(child.path)
                                ? "rgb(230 230 230)"
                                : "",
                            borderRadius: "8px",
                            padding: "5px 8px",
                          }}
                          disabled={child.disabled}
                        >
                          <ListItemText
                            primary={
                              <Typography
                                variant="body4"
                                fontWeight={
                                  location.pathname.includes(child.path) ||
                                  fullUrl.includes(child.path)
                                    ? 700
                                    : 600
                                }
                                color={
                                  location.pathname.includes(child.path) ||
                                  fullUrl.includes(child.path)
                                    ? "#7F56D9"
                                    : "#FFFFFF"
                                }
                              >
                                {child.name}
                              </Typography>
                            }
                          />
                        </ListItemButton>
                      ))}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
          </List>
        </CommonGrid2>
        <List sx={{ width: "100%" }}>
          <ListItemButton
            sx={{
              width: open ? "100%" : "max-content",
              padding: "8px 8px",
            }}
            onClick={handleNotification}
          >
            <CommonTippy
              content={"Activity Center"}
              placement="right"
              disabled={open}
              color="#7F56D9"
              fontWeight={600}
              fontSize={"13px"}
            >
              <Badge
                badgeContent={notification_data?.count}
                invisible={open}
                color="primary"
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: "#EE3939",
                    left: "0px",
                    top: "-10px",
                    width: "fit-content",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    justifyContent: "flex-start",
                    minWidth: "40px",
                  }}
                >
                  <SideBarNotificationIco />
                </ListItemIcon>
              </Badge>
            </CommonTippy>
            <ListItemText
              primary={
                <Fragment>
                  <Typography variant="body4" fontWeight={600} color="#FFFFFF">
                    Activity Center
                  </Typography>
                  <Badge
                    badgeContent={notification_data?.count}
                    color="primary"
                    sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: "#EE3939",
                        left: "0px",
                        width: "fit-content",
                      },
                    }}
                  />
                </Fragment>
              }
            />
          </ListItemButton>
        </List>
        <CommonGrid2
          item
          background="#2D2044"
          padding={"10px"}
          borderRadius={"10px"}
          width={"calc(100% + 20px)"}
          marginLeft={"-10px"}
          cursor="pointer"
          onClick={() => handleNavigation("/about")}
        >
          <CommonGrid2
            display={"flex"}
            flexDirection={"row"}
            gap={"10px"}
            justifyContent={"space-between"}
            alignItems={"flex-start"}
            marginTop={"20px"}
            marginBottom={"10px"}
            minWidth={"fit-content"}
          >
            <CommonGrid2
              display={"flex"}
              flexDirection={"row"}
              gap={"10px"}
              alignItems={"center"}
            >
              <Avatar
                alt="Olivia Rhye"
                src={storageData?.username?.charAt(0)?.toUpperCase()}
                sx={{ width: 40, height: 40, fontWeight: "700" }}
              >
                {storageData?.username?.charAt(0)?.toUpperCase()}
              </Avatar>
              <CommonGrid2 item>
                <Typography
                  variant="body4"
                  fontWeight={"bold"}
                  color="#FFFFFF"
                  lineHeight={"normal"}
                >
                  <EllipseData width={"170px"} textTransform="capitalize">
                    <Tooltip
                      title={storageData?.username}
                      arrow
                      placement="top"
                    >
                      {storageData?.username}
                    </Tooltip>
                  </EllipseData>
                </Typography>
                <Typography
                  variant="body2"
                  color="#8396A8"
                  lineHeight={"normal"}
                >
                  <EllipseData width={"170px"}>
                    <Tooltip title={storageData?.email} arrow placement="top">
                      {storageData?.email}
                    </Tooltip>
                  </EllipseData>
                </Typography>
              </CommonGrid2>
            </CommonGrid2>

            <CommonTippy
              content={"Settings"}
              placement="right"
              color="#7F56D9"
              fontWeight={600}
              fontSize={"13px"}
            >
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/auth/login", "setting");
                }}
              >
                <SettingIco color={"#fff"} />
              </IconButton>
            </CommonTippy>
          </CommonGrid2>
          {open && (
            <CommonGrid2
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              padding={"5px 10px"}
              borderRadius={"5px"}
              background="#251B37"
            >
              <CommonGrid2
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"flex-start"}
                // alignItems={"center"}
              >
                <Typography
                  variant="subtitle2"
                  color="#5DC122"
                  fontWeight={600}
                  padding={"0px"}
                >
                  {storageData?.subscription_details?.current_plan}
                </Typography>
                <Typography
                  variant="subtitle2"
                  color="#8396A8"
                  fontWeight={600}
                  padding={"0px"}
                >
                  <b style={{ color: "#FFFFFF" }}>
                    {storageData?.subscription_details?.days_remaining}
                  </b>{" "}
                  days remaining{" "}
                </Typography>
              </CommonGrid2>
              {storageData?.subscription_details?.current_plan ===
                "Core Monthly" && (
                <Typography variant="h5" fontWeight={700} color="#FFFFFF">
                  <CustomizeSpan>
                    <CreditCoinSmallIco />
                  </CustomizeSpan>
                  {storageData?.subscription_details?.credits_remaining}
                </Typography>
              )}
            </CommonGrid2>
          )}
          {open && (
            <CommonGrid2
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
            >
              <Typography
                variant="body8"
                color="#7F56D9"
                fontWeight={"700"}
                fontSize={"12px"}
                marginBottom={"-8px"}
              >
                Version {updatedVersion}{" "}
                <CustomizeSpan
                  padding="3px 5px"
                  background="#D80027"
                  borderRadius="5px"
                  color="#fff"
                  fontSize="11px"
                  margin="0px 0px 0px 5px"
                  customStyle={{
                    display: "inline-block",
                    animation: "pulse 1.2s infinite ease-in-out",
                  }}
                >
                  New
                </CustomizeSpan>
              </Typography>
            </CommonGrid2>
          )}
        </CommonGrid2>
      </CommonGrid2>
    </Drawer>
  );
};

export default Sidebar;
